<div class="card border-light">
  <div class="card-img-wrapper"></div>

  <div class="card-body">
    <section>
      <h5>Elders Quorum & Relief Society Sunday Lessons</h5>
      <!-- Button trigger modal -->
      <button
        type="button"
        class="btn btn-info"
        data-toggle="modal"
        data-target="#exampleModalLong"
      >
        Click Here!
      </button>

      <!-- Modal -->
      <div
        class="modal fade"
        id="exampleModalLong"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="exampleModalLongTitle"></h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card border-light">
                <div class="card-img-wrapper1"></div>
                <!-- <ul>
                              <li>
                                <a
                                  href="https://www.churchofjesuschrist.org/study/general-conference/2021/04/46wakolo?lang=eng"
                                  target="_blank"
                                  >Aug 22: God Loves His Children, Taniela Waikolo</a
                                >
                              </li>
                              <li>
                                <a
                                  href="https://www.churchofjesuschrist.org/study/general-conference/2021/04/12uchtdorf?lang=eng"
                                  target="_blank"
                                  >Sept 12: God Among Us, Dieter F. Uchtdorf</a
                                >
                              </li>
                              <li>
                                <a
                                  href="https://www.churchofjesuschrist.org/study/general-conference/2021/04/15stevenson?lang=eng"
                                  target="_blank"
                                  >Sept 26: Hearts Knit Together, Gary E. Stevenson</a
                                >
                              </li>
                              <li>
                                <a
                                  href="https://www.churchofjesuschrist.org/study/general-conference/2021/04/16gong?lang=eng"
                                  target="_blank"
                                  >Oct 10: Room at the Inn, Gerrit W. Gong</a
                                >
                              </li>
                              <li>
                                <a
                                  href="https://www.churchofjesuschrist.org/study/general-conference/2021/04/31cook?lang=eng"
                                  target="_blank"
                                  >Oct 24: Bishops—Shepard’s Over the Lord’s Flock, Quintin L.
                                  Cook</a
                                >
                              </li>
                            </ul> -->
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <br />
    <br />
    <section>
      <h1 class="h4">
        <a
          id="user-content-ward-conference-agenda"
          class="anchor"
          aria-hidden="false"
          href="#ward-conference-"
        ></a
        >Announcements/Calendar
      </h1>
      <ul class="list-group list-group-flush">
        <li
          class="list-group-item ml-0 pl-0 mr-0 pr-0"
          *ngFor="let announcement of announcements"
        >
          <div class="d-flex justify-content-start">
            <div class="text-center">
              <span class="text-uppercase font-weight-bold font-size-10">{{
                announcement.date | date: 'd MMM'
              }}</span>
              <div class="fa-3x">
                <i class="fas fa-calendar-day"></i>
              </div>
              <span class="text-uppercase font-weight-bold font-size-10">{{
                announcement.date | date: 'EE'
              }}</span>
            </div>
            <div class="ml-4 mt-2">
              <h2 class="h6 font-weight-bold">
                {{ announcement.title }}
              </h2>
              <p [innerHTML]="announcement.description"></p>
            </div>
          </div>
        </li>
      </ul>
    </section>
  </div>
</div>
